import { render, staticRenderFns } from "./MediaPage.vue?vue&type=template&id=374a96a9&"
import script from "./MediaPage.vue?vue&type=script&lang=js&"
export * from "./MediaPage.vue?vue&type=script&lang=js&"
import style0 from "./MediaPage.vue?vue&type=style&index=0&id=374a96a9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports